angular
  .module('services.SpinnerService', [])
  .service('SpinnerService', [
    function() {
      /**
       *  This object can be populated by calling `addFlag` or `addFlags` functions. It might also
       *  stay empty, we will then have to call `markAsInitialized` to remove spinner.
       *  However, in newer applications, all requests should go through the `ApiService` that
       *  provides more flexibility with SpinnerService.
       *
       * @type {Object}
       */
      var flags = {};

      /**
       *  When false, spinner stays visible. When true, spinner gets removed. When we add a flag,
       *  this boolean is automatically turned on.
       *
       * @type {boolean}
       */
      var isInitialized = false;

      var addFlag = function(key, value) {
        flags[key] = value || false;
        markAsInitialized(); /* eslint-disable-line no-use-before-define */
      };

      var addFlags = function(newFlag) {
        for(var key in newFlag) {
          if(Object.prototype.hasOwnProperty.call(newFlag, key)) {
            addFlag(key, newFlag[key]);
          }
        }
      };

      var getAllFlagsNum = function() {
        return Object.keys(flags).length;
      };

      var getMarkedFlagsNum = function() {
        return Object.keys(flags).filter(function(key) {
          return flags[key] === true;
        }).length;
      };

      /**
       *  Performs 2 checks: first, if isInitialized property has been set to true, second,
       *  if all flags have been marked as true (if there are no flags, also returns true)
       *
       * @returns {boolean} - If all flags are marked or if none have been added and service is
       *                      initialized, returns true to hide spinner
       */
      var allFlagsMarked = function() {
        if (!isInitialized) {
          return false;
        }

        var all = getAllFlagsNum();

        if (all === 0) {
          return true;
        }

        var marked = getMarkedFlagsNum();

        return all === marked;
      };

      var markFlag = function(key) {
        flags[key] = true;
      };

      /**
       * Set isInitialized property as true. Use it when no flags are being added to force hide
       * spinner. When a flag is being added, we automatically run this function.
       *
       * @returns  {undefined}
       */
      var markAsInitialized = function () {
        isInitialized = true;
      };

      return {
        addFlag: addFlag,
        addFlags: addFlags,
        markAsInitialized: markAsInitialized,
        markFlag: markFlag,
        allFlagsMarked: allFlagsMarked,
      };
    }
  ]);
